import {createI18n} from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
// 准备语言环境信息
const messages = {
    en: en,
    zh: zh
}

// 创建 VueI18n 实例
const i18n = createI18n({
    legacy: false, // 必须设置为 false 才能使用 Composition API
    locale: 'en', // 默认语言
    fallbackLocale: 'zh', // 回退语言
    messages
})

export default i18n
